import { apiGetList, apiPost, apiPut, apiDelete } from "services/api";

export const getStations = () =>
  apiGetList("stations", { page: 1, pageSize: 1000 });

export const createStation = (payload) => apiPost("stations/create", payload);

export const updateStation = (payload) => apiPut("stations/update", payload);

export const unbindStationDevice = (stationid) =>
  apiPost("stations/unbind", { stationid: Number(stationid) });

export const deleteStation = (stationid) =>
  apiDelete("stations", { stationid: Number(stationid) });
